require('froala-editor/js/froala_editor.pkgd.min.js');
require('froala-editor/js/plugins/code_view.min.js');
require('froala-editor/js/plugins/align.min.js');
require('froala-editor/js/plugins/link.min.js');
require('froala-editor/js/plugins/lists.min.js');
require('froala-editor/js/plugins/font_family.min.js');
require('froala-editor/js/plugins/quote.min.js');
require('froala-editor/css/froala_editor.pkgd.min.css');
require('froala-editor/css/froala_style.min.css');
require('froala-editor/css/plugins/code_view.min.css');
